var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 94.080002,
    height: 9.1199999,
    viewBox: "0 0 94.079998 9.1199999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath317"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path317"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-oc1",
    transform: "translate(-907.6267,-482.50667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path316",
    d: "m 1823,359 v 582 l -51,-582 z m 0,582 -51,-582 v 582 z",
    style: {
      fill: "#c7c8ca",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#c7c8ca",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    d: "M 1823,941 V 359 h -51 v 582 h 51",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall);
export default __webpack_public_path__ + "static/media/wall.e63291549829ac74b05aa7aa67b85d1b.svg";
export { ForwardRef as ReactComponent };